module.exports = __webpack_public_path__ + "img/262.clean_storefront.a931c846.svg";